import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.regexp.match";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import fetch from 'unfetch';
import middleware from './middleware.js';
import { applyAsyncData, sanitizeComponent, resolveRouteComponents, getMatchedComponents, getMatchedComponentsInstances, flatMapComponents, setContext, middlewareSeries, promisify, getLocation, compile, getQueryDiff, globalHandleError } from './utils.js';
import { createApp, NuxtError } from './index.js';
import NuxtLink from './components/nuxt-link.client.js'; // should be included after ./index.js
// Component: <NuxtLink>

Vue.component(NuxtLink.name, NuxtLink);
Vue.component('NLink', NuxtLink);

if (!global.fetch) {
  global.fetch = fetch;
} // Global shared references


var _lastPaths = [];
var app;
var router;
var store; // Try to rehydrate SSR data from window

var NUXT = window.__NUXT__ || {};
Object.assign(Vue.config, {
  "silent": true,
  "performance": false
});
var errorHandler = Vue.config.errorHandler || console.error; // Create and mount App

createApp().then(mountApp).catch(errorHandler);

function componentOption(component, key) {
  if (!component || !component.options || !component.options[key]) {
    return {};
  }

  var option = component.options[key];

  if (typeof option === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return option.apply(void 0, args);
  }

  return option;
}

function mapTransitions(Components, to, from) {
  var componentTransitions = function componentTransitions(component) {
    var transition = componentOption(component, 'transition', to, from) || {};
    return typeof transition === 'string' ? {
      name: transition
    } : transition;
  };

  return Components.map(function (Component) {
    // Clone original object to prevent overrides
    var transitions = Object.assign({}, componentTransitions(Component)); // Combine transitions & prefer `leave` transitions of 'from' route

    if (from && from.matched.length && from.matched[0].components.default) {
      var fromTransitions = componentTransitions(from.matched[0].components.default);
      Object.keys(fromTransitions).filter(function (key) {
        return fromTransitions[key] && key.toLowerCase().includes('leave');
      }).forEach(function (key) {
        transitions[key] = fromTransitions[key];
      });
    }

    return transitions;
  });
}

function loadAsyncComponents(_x, _x2, _x3) {
  return _loadAsyncComponents.apply(this, arguments);
}

function _loadAsyncComponents() {
  _loadAsyncComponents = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(to, from, next) {
    var _this3 = this;

    var Components, startLoader, err, statusCode, message;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // Check if route path changed (this._pathChanged), only if the page is not an error (for validate())
            this._pathChanged = Boolean(app.nuxt.err) || from.path !== to.path;
            this._queryChanged = JSON.stringify(to.query) !== JSON.stringify(from.query);
            this._diffQuery = this._queryChanged ? getQueryDiff(to.query, from.query) : [];

            if (this._pathChanged && this.$loading.start && !this.$loading.manual) {
              this.$loading.start();
            }

            _context2.prev = 4;
            _context2.next = 7;
            return resolveRouteComponents(to);

          case 7:
            Components = _context2.sent;

            if (!this._pathChanged && this._queryChanged) {
              // Add a marker on each component that it needs to refresh or not
              startLoader = Components.some(function (Component) {
                var watchQuery = Component.options.watchQuery;
                if (watchQuery === true) return true;

                if (Array.isArray(watchQuery)) {
                  return watchQuery.some(function (key) {
                    return _this3._diffQuery[key];
                  });
                }

                return false;
              });

              if (startLoader && this.$loading.start && !this.$loading.manual) {
                this.$loading.start();
              }
            } // Call next()


            next();
            _context2.next = 23;
            break;

          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](4);
            err = _context2.t0 || {};
            statusCode = err.statusCode || err.status || err.response && err.response.status || 500;
            message = err.message || ''; // Handle chunk loading errors
            // This may be due to a new deployment or a network problem

            if (!/^Loading( CSS)? chunk (\d)+ failed\./.test(message)) {
              _context2.next = 20;
              break;
            }

            window.location.reload(true
            /* skip cache */
            );
            return _context2.abrupt("return");

          case 20:
            this.error({
              statusCode: statusCode,
              message: message
            });
            this.$nuxt.$emit('routeChanged', to, from, err);
            next();

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[4, 12]]);
  }));
  return _loadAsyncComponents.apply(this, arguments);
}

function applySSRData(Component, ssrData) {
  if (NUXT.serverRendered && ssrData) {
    applyAsyncData(Component, ssrData);
  }

  Component._Ctor = Component;
  return Component;
} // Get matched components


function resolveComponents(router) {
  var path = getLocation(router.options.base, router.options.mode);
  return flatMapComponents(router.match(path),
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(Component, _, match, key, index) {
      var _Component;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof Component === 'function' && !Component.options)) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return Component();

            case 3:
              Component = _context.sent;

            case 4:
              // Sanitize it and save it
              _Component = applySSRData(sanitizeComponent(Component), NUXT.data ? NUXT.data[index] : null);
              match.components[key] = _Component;
              return _context.abrupt("return", _Component);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x4, _x5, _x6, _x7, _x8) {
      return _ref.apply(this, arguments);
    };
  }());
}

function callMiddleware(Components, context, layout) {
  var _this = this;

  var midd = ["nuxt-custom-headers"];
  var unknownMiddleware = false; // If layout is undefined, only call global middleware

  if (typeof layout !== 'undefined') {
    midd = []; // Exclude global middleware if layout defined (already called before)

    layout = sanitizeComponent(layout);

    if (layout.options.middleware) {
      midd = midd.concat(layout.options.middleware);
    }

    Components.forEach(function (Component) {
      if (Component.options.middleware) {
        midd = midd.concat(Component.options.middleware);
      }
    });
  }

  midd = midd.map(function (name) {
    if (typeof name === 'function') return name;

    if (typeof middleware[name] !== 'function') {
      unknownMiddleware = true;

      _this.error({
        statusCode: 500,
        message: 'Unknown middleware ' + name
      });
    }

    return middleware[name];
  });
  if (unknownMiddleware) return;
  return middlewareSeries(midd, context);
}

function render(_x9, _x10, _x11) {
  return _render.apply(this, arguments);
} // Fix components format in matched, it's due to code-splitting of vue-router


function _render() {
  _render = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(to, from, next) {
    var _this4 = this;

    var fromMatches, nextCalled, _next, matches, Components, layout, _layout, isValid, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, Component, error, _layout2;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(this._pathChanged === false && this._queryChanged === false)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", next());

          case 2:
            // Handle first render on SPA mode
            if (to === from) _lastPaths = [];else {
              fromMatches = [];
              _lastPaths = getMatchedComponents(from, fromMatches).map(function (Component, i) {
                return compile(from.matched[fromMatches[i]].path)(from.params);
              });
            } // nextCalled is true when redirected

            nextCalled = false;

            _next = function _next(path) {
              if (from.path === path.path && _this4.$loading.finish) {
                _this4.$loading.finish();
              }

              if (from.path !== path.path && _this4.$loading.pause) {
                _this4.$loading.pause();
              }

              if (nextCalled) return;
              nextCalled = true;
              next(path);
            }; // Update context


            _context3.next = 7;
            return setContext(app, {
              route: to,
              from: from,
              next: _next.bind(this)
            });

          case 7:
            this._dateLastError = app.nuxt.dateErr;
            this._hadError = Boolean(app.nuxt.err); // Get route's matched components

            matches = [];
            Components = getMatchedComponents(to, matches); // If no Components matched, generate 404

            if (Components.length) {
              _context3.next = 25;
              break;
            }

            _context3.next = 14;
            return callMiddleware.call(this, Components, app.context);

          case 14:
            if (!nextCalled) {
              _context3.next = 16;
              break;
            }

            return _context3.abrupt("return");

          case 16:
            _context3.next = 18;
            return this.loadLayout(typeof NuxtError.layout === 'function' ? NuxtError.layout(app.context) : NuxtError.layout);

          case 18:
            layout = _context3.sent;
            _context3.next = 21;
            return callMiddleware.call(this, Components, app.context, layout);

          case 21:
            if (!nextCalled) {
              _context3.next = 23;
              break;
            }

            return _context3.abrupt("return");

          case 23:
            // Show error page
            app.context.error({
              statusCode: 404,
              message: "This page could not be found"
            });
            return _context3.abrupt("return", next());

          case 25:
            // Update ._data and other properties if hot reloaded
            Components.forEach(function (Component) {
              if (Component._Ctor && Component._Ctor.options) {
                Component.options.asyncData = Component._Ctor.options.asyncData;
                Component.options.fetch = Component._Ctor.options.fetch;
              }
            }); // Apply transitions

            this.setTransitions(mapTransitions(Components, to, from));
            _context3.prev = 27;
            _context3.next = 30;
            return callMiddleware.call(this, Components, app.context);

          case 30:
            if (!nextCalled) {
              _context3.next = 32;
              break;
            }

            return _context3.abrupt("return");

          case 32:
            if (!app.context._errored) {
              _context3.next = 34;
              break;
            }

            return _context3.abrupt("return", next());

          case 34:
            // Set layout
            _layout = Components[0].options.layout;

            if (typeof _layout === 'function') {
              _layout = _layout(app.context);
            }

            _context3.next = 38;
            return this.loadLayout(_layout);

          case 38:
            _layout = _context3.sent;
            _context3.next = 41;
            return callMiddleware.call(this, Components, app.context, _layout);

          case 41:
            if (!nextCalled) {
              _context3.next = 43;
              break;
            }

            return _context3.abrupt("return");

          case 43:
            if (!app.context._errored) {
              _context3.next = 45;
              break;
            }

            return _context3.abrupt("return", next());

          case 45:
            // Call .validate()
            isValid = true;
            _context3.prev = 46;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context3.prev = 50;
            _iterator = Components[Symbol.iterator]();

          case 52:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context3.next = 64;
              break;
            }

            Component = _step.value;

            if (!(typeof Component.options.validate !== 'function')) {
              _context3.next = 56;
              break;
            }

            return _context3.abrupt("continue", 61);

          case 56:
            _context3.next = 58;
            return Component.options.validate(app.context);

          case 58:
            isValid = _context3.sent;

            if (isValid) {
              _context3.next = 61;
              break;
            }

            return _context3.abrupt("break", 64);

          case 61:
            _iteratorNormalCompletion = true;
            _context3.next = 52;
            break;

          case 64:
            _context3.next = 70;
            break;

          case 66:
            _context3.prev = 66;
            _context3.t0 = _context3["catch"](50);
            _didIteratorError = true;
            _iteratorError = _context3.t0;

          case 70:
            _context3.prev = 70;
            _context3.prev = 71;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 73:
            _context3.prev = 73;

            if (!_didIteratorError) {
              _context3.next = 76;
              break;
            }

            throw _iteratorError;

          case 76:
            return _context3.finish(73);

          case 77:
            return _context3.finish(70);

          case 78:
            _context3.next = 84;
            break;

          case 80:
            _context3.prev = 80;
            _context3.t1 = _context3["catch"](46);
            // ...If .validate() threw an error
            this.error({
              statusCode: _context3.t1.statusCode || '500',
              message: _context3.t1.message
            });
            return _context3.abrupt("return", next());

          case 84:
            if (isValid) {
              _context3.next = 87;
              break;
            }

            this.error({
              statusCode: 404,
              message: "This page could not be found"
            });
            return _context3.abrupt("return", next());

          case 87:
            _context3.next = 89;
            return Promise.all(Components.map(function (Component, i) {
              // Check if only children route changed
              Component._path = compile(to.matched[matches[i]].path)(to.params);
              Component._dataRefresh = false; // Check if Component need to be refreshed (call asyncData & fetch)
              // Only if its slug has changed or is watch query changes

              if (_this4._pathChanged && _this4._queryChanged || Component._path !== _lastPaths[i]) {
                Component._dataRefresh = true;
              } else if (!_this4._pathChanged && _this4._queryChanged) {
                var watchQuery = Component.options.watchQuery;

                if (watchQuery === true) {
                  Component._dataRefresh = true;
                } else if (Array.isArray(watchQuery)) {
                  Component._dataRefresh = watchQuery.some(function (key) {
                    return _this4._diffQuery[key];
                  });
                }
              }

              if (!_this4._hadError && _this4._isMounted && !Component._dataRefresh) {
                return Promise.resolve();
              }

              var promises = [];
              var hasAsyncData = Component.options.asyncData && typeof Component.options.asyncData === 'function';
              var hasFetch = Boolean(Component.options.fetch);
              var loadingIncrease = hasAsyncData && hasFetch ? 30 : 45; // Call asyncData(context)

              if (hasAsyncData) {
                var promise = promisify(Component.options.asyncData, app.context).then(function (asyncDataResult) {
                  applyAsyncData(Component, asyncDataResult);

                  if (_this4.$loading.increase) {
                    _this4.$loading.increase(loadingIncrease);
                  }
                });
                promises.push(promise);
              } // Check disabled page loading


              _this4.$loading.manual = Component.options.loading === false; // Call fetch(context)

              if (hasFetch) {
                var p = Component.options.fetch(app.context);

                if (!p || !(p instanceof Promise) && typeof p.then !== 'function') {
                  p = Promise.resolve(p);
                }

                p.then(function (fetchResult) {
                  if (_this4.$loading.increase) {
                    _this4.$loading.increase(loadingIncrease);
                  }
                });
                promises.push(p);
              }

              return Promise.all(promises);
            }));

          case 89:
            // If not redirected
            if (!nextCalled) {
              if (this.$loading.finish && !this.$loading.manual) {
                this.$loading.finish();
              }

              next();
            }

            _context3.next = 106;
            break;

          case 92:
            _context3.prev = 92;
            _context3.t2 = _context3["catch"](27);
            error = _context3.t2 || {};

            if (!(error.message === 'ERR_REDIRECT')) {
              _context3.next = 97;
              break;
            }

            return _context3.abrupt("return", this.$nuxt.$emit('routeChanged', to, from, error));

          case 97:
            _lastPaths = [];
            globalHandleError(error); // Load error layout

            _layout2 = NuxtError.layout;

            if (typeof _layout2 === 'function') {
              _layout2 = _layout2(app.context);
            }

            _context3.next = 103;
            return this.loadLayout(_layout2);

          case 103:
            this.error(error);
            this.$nuxt.$emit('routeChanged', to, from, error);
            next();

          case 106:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[27, 92], [46, 80], [50, 66, 70, 78], [71,, 73, 77]]);
  }));
  return _render.apply(this, arguments);
}

function normalizeComponents(to, ___) {
  flatMapComponents(to, function (Component, _, match, key) {
    if (_typeof(Component) === 'object' && !Component.options) {
      // Updated via vue-router resolveAsyncComponents()
      Component = Vue.extend(Component);
      Component._Ctor = Component;
      match.components[key] = Component;
    }

    return Component;
  });
}

function showNextPage(to) {
  // Hide error component if no error
  if (this._hadError && this._dateLastError === this.$options.nuxt.dateErr) {
    this.error();
  } // Set layout


  var layout = this.$options.nuxt.err ? NuxtError.layout : to.matched[0].components.default.options.layout;

  if (typeof layout === 'function') {
    layout = layout(app.context);
  }

  this.setLayout(layout);
} // When navigating on a different route but the same component is used, Vue.js
// Will not update the instance data, so we have to update $data ourselves


function fixPrepatch(to, ___) {
  var _this2 = this;

  if (this._pathChanged === false && this._queryChanged === false) return;
  var matches = [];
  var instances = getMatchedComponentsInstances(to, matches);
  var Components = getMatchedComponents(to, matches);
  Vue.nextTick(function () {
    instances.forEach(function (instance, i) {
      if (!instance || instance._isDestroyed) return; // if (
      //   !this._queryChanged &&
      //   to.matched[matches[i]].path.indexOf(':') === -1 &&
      //   to.matched[matches[i]].path.indexOf('*') === -1
      // ) return // If not a dynamic route, skip

      if (instance.constructor._dataRefresh && Components[i] === instance.constructor && instance.$vnode.data.keepAlive !== true && typeof instance.constructor.options.data === 'function') {
        var newData = instance.constructor.options.data.call(instance);

        for (var key in newData) {
          Vue.set(instance.$data, key, newData[key]);
        } // Ensure to trigger scroll event after calling scrollBehavior


        window.$nuxt.$nextTick(function () {
          window.$nuxt.$emit('triggerScroll');
        });
      }
    });
    showNextPage.call(_this2, to);
  });
}

function nuxtReady(_app) {
  window.onNuxtReadyCbs.forEach(function (cb) {
    if (typeof cb === 'function') {
      cb(_app);
    }
  }); // Special JSDOM

  if (typeof window._onNuxtLoaded === 'function') {
    window._onNuxtLoaded(_app);
  } // Add router hooks


  router.afterEach(function (to, from) {
    // Wait for fixPrepatch + $data updates
    Vue.nextTick(function () {
      return _app.$nuxt.$emit('routeChanged', to, from);
    });
  });
}

function mountApp(_x12) {
  return _mountApp.apply(this, arguments);
}

function _mountApp() {
  _mountApp = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(__app) {
    var Components, _app, layout, mount, clientFirstMount;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // Set global variables
            app = __app.app;
            router = __app.router;
            store = __app.store; // Resolve route components

            _context4.next = 5;
            return Promise.all(resolveComponents(router));

          case 5:
            Components = _context4.sent;
            // Create Vue instance
            _app = new Vue(app); // Load layout

            layout = NUXT.layout || 'default';
            _context4.next = 10;
            return _app.loadLayout(layout);

          case 10:
            _app.setLayout(layout); // Mounts Vue app to DOM element


            mount = function mount() {
              _app.$mount('#__nuxt'); // Add afterEach router hooks


              router.afterEach(normalizeComponents);
              router.afterEach(fixPrepatch.bind(_app)); // Listen for first Vue update

              Vue.nextTick(function () {
                // Call window.{{globals.readyCallback}} callbacks
                nuxtReady(_app);
              });
            }; // Enable transitions


            _app.setTransitions = _app.$options.nuxt.setTransitions.bind(_app);

            if (Components.length) {
              _app.setTransitions(mapTransitions(Components, router.currentRoute));

              _lastPaths = router.currentRoute.matched.map(function (route) {
                return compile(route.path)(router.currentRoute.params);
              });
            } // Initialize error handler


            _app.$loading = {}; // To avoid error while _app.$nuxt does not exist

            if (NUXT.error) _app.error(NUXT.error); // Add beforeEach router hooks

            router.beforeEach(loadAsyncComponents.bind(_app));
            router.beforeEach(render.bind(_app)); // If page already is server rendered

            if (!NUXT.serverRendered) {
              _context4.next = 21;
              break;
            }

            mount();
            return _context4.abrupt("return");

          case 21:
            // First render on client-side
            clientFirstMount = function clientFirstMount() {
              normalizeComponents(router.currentRoute, router.currentRoute);
              showNextPage.call(_app, router.currentRoute); // Don't call fixPrepatch.call(_app, router.currentRoute, router.currentRoute) since it's first render

              mount();
            };

            render.call(_app, router.currentRoute, router.currentRoute, function (path) {
              // If not redirected
              if (!path) {
                clientFirstMount();
                return;
              } // Add a one-time afterEach hook to
              // mount the app wait for redirect and route gets resolved


              var unregisterHook = router.afterEach(function (to, from) {
                unregisterHook();
                clientFirstMount();
              }); // Push the path and let route to be resolved

              router.push(path, undefined, function (err) {
                if (err) errorHandler(err);
              });
            });

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _mountApp.apply(this, arguments);
}